export default {
  // Override the info variant to use solid primary color instead of light primary
  // This fixes the visibility issue for trial status badges
  info: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary text-white",
}